import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { BehaviorSubject, Observable, of } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public inAuthProcess = new BehaviorSubject<boolean>(false);
  
  constructor(private router: Router,
    private oidcSecurityService: OidcSecurityService
  ) { }

  setInAuthProcess(isInAuthProcess: boolean) {
    this.inAuthProcess.next(isInAuthProcess);
  }

  getInAuthProcess(): Observable<boolean> {
    return this.inAuthProcess.asObservable();
  }

  get isLoggedIn() {
    return this.oidcSecurityService.isAuthenticated$;    
  }

  startAuthentication() {
    
    return of(this.oidcSecurityService.authorize());    
  }

  logout() {
    this.oidcSecurityService.logoff();
  }

  callback() {
    this.setInAuthProcess(false);
    this.oidcSecurityService.checkAuth().subscribe(() => {      
      let redirectUrl = localStorage['_MYPV_redirectUrl'];
      if (redirectUrl) {
        this.router.navigateByUrl(redirectUrl);
        localStorage.removeItem('_MYPV_redirectUrl');
      } else {
        this.router.navigateByUrl("/home");
      }      
    }, (err) => {
      console.error(err);
    });
  }

  getAccessToken() {
    return this.oidcSecurityService.getIdToken();
  }
}
